import { runtimeConfig } from "./runtimeConfig";

export interface ApiConfig {
  baseUrl: string;
  timeoutMs: number;
}

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

const rawBaseUrl = runtimeConfig.TOWER_API_BASE_URL || "http://localhost:5000";

const rawTimeoutMs = Number(runtimeConfig.TOWER_API_TIMEOUT_MS || "15000");

export const apiConfig: ApiConfig = {
  baseUrl: trimTrailingSlash(rawBaseUrl),
  timeoutMs: Number.isFinite(rawTimeoutMs) ? rawTimeoutMs : 15000,
};
